import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Card from '@taglivros/oef_componentes/build/components/card'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { useGlobal } from '../../../../../contexts/GlobalContext'
import { BOTAO_SEGUIR_CANCELAMENTO, BOTAO_SUSPENDER } from '../constantsCancelarAssinatura'
import { EVENTOS_GA, URLS } from '../../../../../constants'
import { enviaEventoGA } from '../../../../../utils/helpers/helpersGA'
import Navegacao from '../components/Navegacao/Navegacao'
import TextoSuspensao from './TextoSuspensao'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../../utils/helpers/helpersAssinatura'

const Container = styled.div`
  max-width: 74%;
  margin-bottom: 10px;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    max-width: 100%;
  }

  h4 {
    margin: 0 0 8px;
    color: ${StyleGuide.cores.cinza500};
    ${StyleGuide.boldFonte}
  }

  p {
    width: 800px;
    margin: 2px 0;

    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      width: 100%;
    }
  }
`

const BotoesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: 50px 0 0;
  width: 100%;

  @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 0;
    justify-content: flex-end;
  }

  button {
    &:first-of-type {
      margin-right: 15px;
    }

    @media(max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 16px;
      margin: 0;
    }
  }
`

const Suspensao = () => {
  const { modalidadeURL, dadosGlobaisAssociado } = useGlobal()
  const [ plano, setPlano ] = useState( '' )
  const handleEtapaAnterior = () => {
    enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES.SEGUIR_CANCELAMENTO_FORMULARIO )
  }

  const handleProximaEtapa = () => {
    enviaEventoGA( EVENTOS_GA.CANCELAMENTO.FLUXO, EVENTOS_GA.CANCELAMENTO.ACOES.SEGUIR_CANCELAMENTO_SUSPENSAO_FORMULARIO )
  }

  useEffect( () => {
    setPlano( getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL ).plano )
  }, [] )

  return (
    <Card
      className="card"
      largura="100%"
    >
      <Container>
        <TextoSuspensao />
      </Container>

      <BotoesWrapper>
        <Navegacao
          eventoBotaoContinuar={ handleProximaEtapa }
          eventoBotaoVoltar={ handleEtapaAnterior }
          hasMargin
          testIdName="suspender"
          tituloContinuar={ BOTAO_SUSPENDER }
          tituloVoltar={ BOTAO_SEGUIR_CANCELAMENTO }
          urlParaContinuar={ `/${modalidadeURL}/${URLS.PLANO}/${URLS.CANCELAR_ASSINATURA_SUSPENSAO}/${URLS.CANCELAR_ASSINATURA_MOTIVOS_SUSPENSAO}` }
          urlParaVoltar={ `/${modalidadeURL}/${URLS.PLANO}/${URLS.CANCELAR_ASSINATURA_MOTIVOS_CANCELAMENTO}` }
        />
      </BotoesWrapper>
    </Card>
  )
}

export default Suspensao


